import { BookingValues } from "./bookingValues";
import { SplitValues } from "./splitValues";
import { Depot } from "./depots";
import { InvestmentValues } from "./investmentValues";
import type { Account, Currency, TransactionV2 } from "@rentablo/api/apiv1";
import type { Symbol } from "@rentablo/api/apiv1";

export interface TransactionWizardContext {
  currencies: Currency[];
  symbol?: Symbol;
  sepaTransaction?: TransactionV2;
  depot?: Account;
  selectableDepots?: Depot[];
  error?: ApiException;
  validationError?: string;
  bookingValues: BookingValues;
  bookingValuesToRestore?: BookingValues;
  investmentValues: InvestmentValues;
  splitValues?: SplitValues;
  sourceInvestmentValues?: {
    id?: number;
    name?: string;
  };
  skipSummaryStep?: boolean;
}

export const defaultContext = {
  currencies: [],
  symbol: undefined,
  sepaTransaction: undefined,
  depot: undefined,
  selectableDepots: undefined,
  error: undefined,
  bookingValues: {
    date: new Date(),
    commission: 0,
    taxAmount: 0,
    exchangeRate: 1,
  },
  bookingValuesToRestore: undefined,
  investmentValues: {
    investmentCurrency: "EUR",
  },
  splitValues: {
    date: new Date(),
    isReverse: false,
  },
  skipSummaryStep: false,
};
